import { createConfirmation } from "react-confirm";
import ImageReadDlg from "./ImageReadDlg";

export const showImageReadDlg = createConfirmation(ImageReadDlg);
